import React from 'react';
import { Route, IndexRoute} from 'react-router';

import Error404Page from 'modules/Errors/components/Error404Page';
import Error500Page from 'modules/Errors/components/Error500Page';
import ErrorPageContainer from 'modules/Errors/components/ErrorPageContainer';
import AdvertWrapper from 'modules/Common/components/AdvertWrapper';

const error404Components = {
  Error404Page,
  AdvertWrapper
}

const error500Components = {
  Error500Page,
  AdvertWrapper
}

const errorRoutes = (
  <Route path="error">
    <Route path="404" component={ErrorPageContainer}>
      <IndexRoute components={error404Components}/>
      <Route path="*" components={error404Components}/>
    </Route>
    <Route path="500" component={ErrorPageContainer}>
      <IndexRoute components={error500Components}/>
      <Route path="*" components={error500Components}/>
    </Route>
  </Route>
);

export default errorRoutes;



// WEBPACK FOOTER //
// ./modules/Errors/routes.js